import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { DialogData, RadioEventData } from '../../model/data.model';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import productConfig from '../../life-config/productCodeConfig.json';


// import { EditQuoteModel } from '../../model/edit-quote-modal';

@Component({
    selector: 'app-bi-modal',
    templateUrl: './bi-modal.component.html',
    styleUrls: ['./bi-modal.component.css']
})
export class BiModalComponent implements OnInit {

    editQuote: FormGroup;
    radioEventData: RadioEventData;
    uuid: string;
    proposalId: string;
    // Remove any later - Use Interface / class
    // on getting finla UI add to class
    editQuoteModalJson: any = lifeQuoteJson.editModalInitialJson;
    productType: object = lifeProductType.componentClassName;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    productConf = productConfig.product_type;
    year: any;
    month: any;
    day: any;
    minAge: number;
    currentDate: any;
    editQuoteMaxDate: any;
    quoteCounter: any;
    imageLoad: any;
    dataObtained: any;
    occupationList: any;
    quoteBlock: any;
    // editQuoteInfo: EditQuoteModel[];

    get formReceievedEditQuote(): FormArray {
        return this.editQuote.get('editQuoteInfo') as FormArray;
    }


    constructor(
        private dialogRef: MatDialogRef<BiModalComponent>,
        private formbuild: FormBuilder,
        private apiService: ApiService,
        private datePipe: DatePipe,
        private sharedData: SharedApiService,

        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
        // this.editModalJson ? this.editModalJson['gender'] : '1'

        // Initilaizing form
        this.editQuote = this.formbuild.group({

            occupation: ['', [Validators.required]],
            salutation: ['', [Validators.required]],
            firstName: ['', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(20),
                Validators.pattern(new RegExp('^[a-zA-Z]*$'))]
            ],
            middleName: ['', [
                Validators.minLength(1),
                Validators.maxLength(20),
                Validators.pattern(new RegExp('^[a-zA-Z]*$'))]],
            // tslint:disable-next-line: max-line-length
            lastName: ['', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(20),
                Validators.pattern(new RegExp('^[a-zA-Z]*$'))]],
        });



        this.dataObtained = data['editQuoteInfo'];
        this.occupationList = data['occupationList'];
        // this.editQuote.patchValue({ occupation: this.dataObtained['lifeassured']['occupation'] });
        // this.editQuote.patchValue({ salutation: this.dataObtained['lifeassured']['salutation'] });
        // this.editQuote.patchValue({ firstName: this.dataObtained['lifeassured']['first_name'] });

        this.uuid = data['uuid'],
        this.proposalId = data['proposalId'];
        this.quoteBlock = data['proposalId'];
        if ( this.dataObtained && this.dataObtained ['lifeassured']['occupation']) {
            this.editQuote.patchValue ({ occupation : this.dataObtained ['lifeassured']['occupation']});
        }


    }


    destroySubject$: Subject<void> = new Subject();
    editModalConfData: object;
    inputValueFromCmp: number | string;
    calValFromCmp: object;
    editModalJson: any;
    annualIncomeInComma: any;
    numberInWords: any;
    annualIncomeData: any;

    // Unable to add private class
    editQuoteResponse: any;


    editModalJsonItems(i: number) {

        // Getting Edit Quote Info Array
        return this.formReceievedEditQuote.controls[i].get('editQuoteInfo') as FormArray;

    }




    // Retreving value from edit modal form and saving it to modal/Class or pass to api

    saveEditQuote(isvalid: boolean, e: any) {

        e.preventDefault();
        const editQuoteUrl = this.apiUrl['apiV2LifeProposal'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['update_proposal'];

        // Check edit quote form status
        if (isvalid) {

            const data = {


                lifeassured: {
                    salutation: this.editQuote.get('salutation').value,
                    first_name: this.editQuote.get('firstName').value,
                    middle_name: this.editQuote.get('middleName').value,
                    last_name: this.editQuote.get('lastName').value,
                    occupation_id: this.editQuote.get('occupation').value,
        
                }

            };

            // Exposing data to api
            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'], data).subscribe(res => {
                    this.editQuoteResponse = res['response'];
                    if (this.editQuoteResponse) {

                        this.dialogRef.close({ event: 'close', data: this.editQuoteResponse });
                    }

                }, err => {
                    this.dialogRef.disableClose = true;
                });
        }
    }


    getBI() {
        this.sharedData.getBenefitIllustration(this.proposalId, this.uuid).subscribe(bires => {
            if (bires) {

                this.sharedData.callMethodForBIComponent(bires);

            }

        });
    }

    ngOnInit() {
    }

    /**
     * on modal cancel click
     */

    cancelEdit() {

        this.dialogRef.close();

    }


}

